import { CopyOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Radio, Row, Tag, Typography } from "antd";
import React from "react";

import { TOR_POLICY_OPTIONS } from "./constants";
import type { PreviewTorProps } from "./types";
import { formatCurrency } from "../../../../../libs/utils/formatter/formatCurrency";

const { Text } = Typography;

export const PreviewTor = (props: PreviewTorProps) => {
  const {
    title = "TOR Rules — Previous Term",
    values,
    onCopy,
    showCopyButton = Boolean(onCopy),
    hasPreviousRules = true,
  } = props;

  return (
    <Card
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>{title}</span>
          <Tag style={{ backgroundColor: "#F5F5F5", color: "#000",lineHeight: "8px" }}>Locked</Tag>
        </div>
      }
      bodyStyle={{ paddingTop: 16 }}
    >
      <Form layout="vertical">
        {!hasPreviousRules ? (
          <Text type="secondary">No TOR rules on the previous term.</Text>
        ) : (
          <>
            <Form.Item label="Select TOR Policy">
              <Radio.Group value={values.torRuleCondition} disabled>
                <Row gutter={[16, 24]}>
                  {TOR_POLICY_OPTIONS.map((option) => (
                    <Col span={8} key={option.value}>
                      <Radio value={option.value}>{option.label}</Radio>
                    </Col>
                  ))}
                </Row>
              </Radio.Group>
            </Form.Item>

            {values.torRules.map((rule, index) => (
              <Row key={`preview-tor-rule-${index}`} gutter={[6, 12]}>
                <Col span={4}>
                  <Form.Item label="TOR %">
                    <Text>{rule.torPercent}</Text>
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item label="Min Sale">
                    <Text>{formatCurrency(rule.minSale)}</Text>
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item label="Max Sale">
                    <Text>{formatCurrency(rule.maxSale)}</Text>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item label="Min Limit">
                    <Text>{formatCurrency(rule.minLimit)}</Text>
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item label="Upto Limit">
                    <Text>{formatCurrency(rule.uptoLimit)}</Text>
                  </Form.Item>
                </Col>
              </Row>
            ))}
          </>
        )}

      </Form>

      {showCopyButton && onCopy && hasPreviousRules ? (
        <Button
          type="dashed"
          htmlType="button"
          icon={<CopyOutlined />}
          block
          onClick={onCopy}
        >
          <Text className="ag-primary fontWeight600" style={{ fontSize: "14px" }}>
            Copy into New Term
          </Text>
        </Button>
      ) : null}
    </Card>
  );
};
